var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { useLanguage } from '@base/LanguageProvider';
import { useApiVersion } from '@data/apiVersion/apiVersionActions';
import { useHover } from '@hooks/useHover';
import { appColors } from '@styled/useTheme';
import React from 'react';
import { FaCog, FaQuestionCircle, FaUsers } from 'react-icons/fa';
import { VscVersions } from 'react-icons/vsc';
import { Link } from 'react-router-dom';
import { useAuth } from '../../providers/AuthProvider';
var MENU_CONTAINER = {
    borderRadius: 5,
    overflow: 'hidden',
    color: 'black',
};
var SECTION_HEADER = {
    display: 'flex',
    alignItems: 'center',
    padding: 11,
};
var CONFIG_ITEM = {
    height: 28,
    padding: 11,
    paddingTop: 6,
    paddingBottom: 6,
    cursor: 'pointer',
};
var ITEM_TITLE = {
    margin: 0,
    paddingLeft: 26,
};
var SECTION = {
    borderBottom: '1px solid #E7EAF0',
};
var SectionDataMap = {
    'Users & Permissions': {
        Icon: FaUsers,
        feature: 'canSeeUsersGroupsManagement',
        options: [{ title: 'Users & Groups', path: 'admin/users-groups' }],
    },
    System: {
        Icon: FaCog,
        options: [
            { title: 'Entry Links', path: 'admin/entry-links', feature: 'canSeeEntryLinks' },
            { title: 'Input Setup', path: 'admin/input-setup', feature: 'canSeeInputSetup' },
            { title: 'Version & Year Locks', path: 'admin/locks', feature: 'canSeeYearVersionLocks' },
            { title: 'Audit Logs', path: 'admin/audit', feature: 'canSeeAuditLogs' },
        ],
    },
    Support: {
        Icon: FaQuestionCircle,
        options: [
            {
                title: 'Help Center',
                path: 'https://support.farseer.io/hc/',
                action: function () {
                    window.open('https://support.farseer.io/hc/', '_blank');
                },
            },
            {
                title: 'Contact Support',
                path: '',
                action: function () {
                    //@ts-ignore
                    zE('messenger', 'open');
                },
            },
        ],
    },
};
function ConfigItem(_a) {
    var action = _a.action, path = _a.path, title = _a.title, closeHandler = _a.closeHandler;
    var L = useLanguage().L;
    var _b = __read(useHover(), 2), ref = _b[0], isHovered = _b[1];
    var style = {
        backgroundColor: isHovered ? appColors.neutral.w100 : appColors.ui.white,
    };
    var content = React.createElement("p", { style: ITEM_TITLE }, L(title));
    return (React.createElement("div", { ref: ref, style: style }, !action ? (React.createElement(Link, { onClick: closeHandler, style: __assign(__assign({}, CONFIG_ITEM), { display: 'block', color: 'inherit', textDecoration: 'inherit' }), to: '/' + path }, content)) : (React.createElement("div", { style: CONFIG_ITEM, onClick: function () {
            action();
            closeHandler();
        } }, content))));
}
function Section(_a) {
    var sectionData = _a.sectionData, title = _a.title, closeHandler = _a.closeHandler;
    var L = useLanguage().L;
    var user = useAuth().user;
    var items = sectionData.options
        .filter(function (o) { return !o.feature || (user === null || user === void 0 ? void 0 : user.features[o.feature]); })
        .map(function (o, idx) { return React.createElement(ConfigItem, __assign({ key: o.path }, o, { closeHandler: closeHandler })); });
    if (items.length === 0) {
        return null;
    }
    return (React.createElement("div", { style: SECTION },
        React.createElement("div", { style: SECTION_HEADER },
            React.createElement(sectionData.Icon, { style: { marginRight: 10 } }),
            React.createElement("label", { style: { margin: 0, color: 'black', fontWeight: 'bold' } }, L(title))),
        items));
}
function ConfigMenu(_a) {
    var _b;
    var closeMenuHandler = _a.closeMenuHandler;
    var L = useLanguage().L;
    var apiVersion = useApiVersion();
    var user = useAuth().user;
    var sections = Object.entries(SectionDataMap)
        .filter(function (_a) {
        var _b = __read(_a, 2), sectionData = _b[1];
        return !sectionData.feature || (sectionData.feature && (user === null || user === void 0 ? void 0 : user.features[sectionData.feature]));
    })
        .map(function (_a, idx) {
        var _b = __read(_a, 2), title = _b[0], sectionData = _b[1];
        return (React.createElement(Section, { key: "selection-".concat(idx), sectionData: sectionData, title: title, closeHandler: closeMenuHandler }));
    });
    return (React.createElement("div", { style: MENU_CONTAINER },
        sections,
        React.createElement("div", { style: SECTION },
            React.createElement("div", { style: SECTION_HEADER },
                React.createElement(VscVersions, { style: { marginRight: 10 } }),
                React.createElement("label", { style: { margin: 0, color: 'black', fontWeight: 'bold' } },
                    L('Application Version'),
                    ": ", (_b = apiVersion === null || apiVersion === void 0 ? void 0 : apiVersion.data) === null || _b === void 0 ? void 0 :
                    _b.data)))));
}
export default ConfigMenu;
